import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from '@mui/material';
import { OfflineButton } from './OfflineButton';
export const HomePageIcon = ({ text, icon, innerHtml, onClick, supportsOffline = false, width = '7rem', textColor = 'primary', marginTop = '0px', }) => {
    if (supportsOffline) {
        return (_jsx(Button, { onClick: onClick, variant: "text", sx: {
                textAlign: 'center',
                width: width,
                '&:hover': {
                    backgroundColor: '#C8CDD0',
                },
            }, children: _jsxs(Box, { children: [innerHtml, icon, _jsx(Box, { mt: marginTop, sx: { color: textColor }, children: text })] }) }));
    }
    return (_jsx(OfflineButton, { noBorder: true, onClick: onClick, variant: "text", sx: {
            textAlign: 'center',
            width: width,
            '&:hover': {
                backgroundColor: '#C8CDD0',
            },
        }, text: _jsxs(Box, { children: [innerHtml, icon, _jsx(Box, { mt: marginTop, sx: { color: textColor }, children: text })] }) }));
};
